import { useTranslation } from "react-i18next";

/** DUE-221 (audit C8): admin pages rendered a silent blank screen on any
 * query error. Every admin page's isError branch renders this. */
export function AdminErrorState({ onRetry }: { onRetry: () => void }): JSX.Element {
  const { t } = useTranslation("admin");
  return (
    <div data-testid="admin-error" style={{ padding: 24, textAlign: "center", color: "var(--d-fg)" }}>
      <p style={{ marginBottom: 16 }}>{t("common.load_failed")}</p>
      <button type="button" onClick={onRetry}
        style={{ height: 48, borderRadius: 999, padding: "0 24px", background: "var(--d-violet)", color: "var(--d-ink)" }}>
        {t("common.retry")}
      </button>
    </div>
  );
}
